module.exports = __webpack_public_path__ + "img/full6-min.274d0967.png";